<template>

  <div>
    <modern-upload-field
      ref="uploadField"
      :label="label"
      :name="name"
      :value="value"
      accept="image/jpeg,image/png,image/webp,image/gif"
      :required="required"
      :uploading="uploading"
      :has-error="fileError || hasError"
      :error-message="errorMessage"
      hint="Choose race photo (.jpg, .png, .webp)"
      @file-selected="onFileSelect"
    ></modern-upload-field>
    <modal 
      name="cropImage" 
      :clickToClose="false" 
      :adaptive="true" 
      :scrollable="true" 
      height="auto" 
      width="90%" 
      maxWidth="600"
      @before-open="resetModalHeight"
    >
      <div class="rup-dialog">
        <div class="rup-dialog-header">
          <span class="rup-dialog-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 14a8 8 0 0 1 16 0"/>
              <path d="M12 6v12"/>
              <path d="M8 10l4-4 4 4"/>
            </svg>
          </span>
          <div>
            <h3 class="rup-dialog-title">Crop Image</h3>
            <p class="rup-dialog-sub">Adjust the race photo before upload</p>
          </div>
          <button type="button" class="rup-close-btn" @click="cancel()">×</button>
        </div>
        <div class="rup-dialog-body">
          <VueCropper v-show="selectedFile" ref="cropper" :viewMode="3" :zoomable="false" :aspect-ratio="4/3" :src="selectedFile" alt="Source Image" class="rup-cropper"></VueCropper>
          <div v-if="uploading" class="rup-progress">
            <div class="rup-progress-bar"></div>
          </div>
        </div>
        <div class="rup-dialog-footer">
          <button type="button" class="rup-ghost-btn" @click="cancel()">Cancel</button>
          <button type="button" class="rup-primary-btn" id="save-race-image" :disabled="cropSaving" @click="cropImage()">
            {{ cropSaving ? 'Saving...' : 'Save' }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs'
const Compress = require('client-compress')
import 'cropperjs/dist/cropper.css'
import service from '@/services/index'
import { mapActions } from 'vuex'
import ModernUploadField from '@/components/Forms/ModernUploadField'

const resource = service.resource('races/upload-image')

export default {
  components: { VueCropper, ModernUploadField },
  // props: ['image_name'],
   props: {
    label: {
      required: false,
      type: String
    },
    value: {
      required: true
    },
    name: {
      required: true,
      type: String
    },
    errorMessage: {
      required: false,
      type: String
    },
    hasError: {
      required: false
    },
    required: {
      type: Boolean
    }
  },
  data() {
    return {
      input: '',
      mime_type: '',
      cropedImage: '',
      autoCrop: false,
      selectedFile: '',
      image: '',
      dialog: false,
      files: '',
      file_name:'',
      fileError:false,
      uploading: false,
      cropSaving: false
    }
  },
  watch: {
    value: function (newVal) {
      this.input = newVal
    }
  },
  computed: {

  },
  methods: {
    cropImage() {
      console.log("crop image inside")
      // const userId = this.$route.params.user_id
      this.cropedImage = this.$refs.cropper.getCroppedCanvas().toDataURL()    
      this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
          const size = blob.size/1024
          console.log("size---",size)
          if(size > 200){
            this.compressImage(blob) //Compress image if file size is larger than 200kb
            //  this.fileError=true
            //  this.$emit('input', null)
            //  this.showCropWindow = false  
          }else { 
            this.fileError=false
            const formData = new FormData()
            formData.append('file', blob, this.file_name)  
            this.saveImageButton()     
            this.addTaskToQueue('saveRacePhoto')
              resource.save(formData)
                .then(({ body }) => {
                this.$emit('input', body.url)
                this.removeTaskFromQueue('saveRacePhoto')
                this.$modal.hide('cropImage')      
              }).finally(() => {
                this.resetSaveImageButton()
              })
          }
      }, this.mime_type)
    },
    onFileSelect(e) {
      const file = e.target.files[0]
      if (!file) {
        return
      }
      this.file_name = file.name
      const size = file.size/1024
      console.log("size---",size)
      if(size <= 200){
        const imgFile = new FormData()
        imgFile.append('file', file)
         this.addTaskToQueue('saveRacePhoto')
         this.uploading = true
          resource.save(imgFile)
            .then(({ body }) => {
            this.$emit('input', body.url)
            this.removeTaskFromQueue('saveRacePhoto')
          }).finally(() => {
            this.uploading = false
          })
      }else{
        this.mime_type = file.type
        if (typeof FileReader === 'function') {
          this.dialog = true
          const reader = new FileReader()
          reader.onload = (event) => {
            this.selectedFile = event.target.result
            this.$refs.cropper.replace(this.selectedFile)
          }
          reader.readAsDataURL(file)
          this.$modal.show('cropImage')
        } else {
          alert('Sorry, FileReader API not supported')
        }
      }
    },
    compressImage(blob){
      console.log("Compress Image")
      const options = {
        targetSize: 0.2,
        quality: 0.75,
        maxWidth: 800,
        maxHeight: 600
      }
      const compress = new Compress(options)
      compress.compress([blob]).then((conversions) => {        
        const { photo } = conversions[0]
        const size = photo.data.size/1024
        console.log("Compress image size---",size)
        if(size > 200){
          this.fileError=true
          this.$emit('input', null)
          this.resetSaveImageButton()
          this.$modal.hide('cropImage')  
        }else {             
          this.fileError=false
          const formData = new FormData()
          formData.append('file', photo.data)
          this.saveImageButton()     
          this.addTaskToQueue('saveRacePhoto')
          resource.save(formData)
            .then(({ body }) => {
            this.$emit('input', body.url)
            this.removeTaskFromQueue('saveRacePhoto')
            this.$modal.hide('cropImage')      
          }).finally(() => {
            this.resetSaveImageButton()
          })
        } 
      })
    },
    saveImageButton() {
        this.cropSaving = true
        this.uploading = true
      },
    resetSaveImageButton() {
        this.cropSaving = false
        this.uploading = false
    },
    resetModalHeight() {
      // Fix for vue-js-modal height calculation issue
      this.$nextTick(() => {
        const modal = this.$modal
        if (modal && modal.modal && modal.modal.renderedHeight) {
          modal.modal.renderedHeight = ''
        }
      })
    },
    onClose() {
      this.$modal.hide('cropImage')      
    },
    cancel(){
      if (this.$refs.uploadField) {
        this.$refs.uploadField.clear()
      }
      this.$modal.hide('cropImage')   
    },
     ...mapActions({
      addTaskToQueue: 'LoadingQueue/addTaskToQueue',
      removeTaskFromQueue: 'LoadingQueue/removeTaskFromQueue'
    })
  },
}
</script>
<style scoped>
.rup-dialog {
  background: #fff;
}

.rup-dialog-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #f0f0f5;
}

.rup-dialog-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f0effe;
  color: #5b4fcf;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 36px;
}

.rup-dialog-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
}

.rup-dialog-sub {
  font-size: 12px;
  color: #8a8a9a;
  margin: 3px 0 0;
}

.rup-close-btn {
  width: 30px;
  height: 30px;
  border: 1px solid #e8e8ed;
  border-radius: 50%;
  background: #fff;
  color: #8a8a9a;
  font-size: 20px;
  line-height: 1;
  margin-left: auto;
  cursor: pointer;
}

.rup-close-btn:hover {
  color: #c0392b;
  border-color: #f2c7c1;
  background: #fff6f4;
}

.rup-dialog-body {
  padding: 1.5rem 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.rup-cropper {
  width: 100%;
  max-height: 400px;
  border-radius: 8px;
  overflow: hidden;
}

.rup-progress {
  width: 100%;
  height: 3px;
  border-radius: 999px;
  background: #f0f0f5;
  overflow: hidden;
}

.rup-progress-bar {
  width: 45%;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #5b4fcf, #9c8dff);
  animation: rup-progress 1.1s ease-in-out infinite;
}

.rup-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  border-top: 1px solid #f0f0f5;
  padding: 1rem 1.75rem 1.5rem;
}

.rup-ghost-btn,
.rup-primary-btn {
  height: 36px;
  border-radius: 8px;
  padding: 0 18px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
}

.rup-ghost-btn {
  border: 1.5px solid #e0e0ea;
  background: #fff;
  color: #5b4fcf;
}

.rup-primary-btn {
  border: 0;
  background: #5b4fcf;
  color: #fff;
}

.rup-primary-btn:hover:not(:disabled) {
  background: #4338ca;
}

.rup-primary-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@keyframes rup-progress {
  0% { transform: translateX(-120%); }
  100% { transform: translateX(240%); }
}
</style>



// WEBPACK FOOTER //
// UploadPhoto.vue?a612848e